export default function SET_STUDENT_PANEL_META_DATA(state, studentPanelMetaData) {
    state.studentPanelMetaData = studentPanelMetaData;
}